export const camelCaseReplace = (key) =>
  key
    ?.replace(/([A-Z])/g, ' $1')
    ?.replace(/^./, (str) => str.toUpperCase())
    ?.replace('_', ' ') ||
  key ||
  '';

export const nameFormat = (name, replacementValue = null) =>
  name?.replace(/_/g, ' ')?.replace(/\b\w/g, (l) => l?.toUpperCase()) ||
  replacementValue ||
  '';

export const splitWords = (string) => string.split(/(?=[A-Z])/).join(' ');

export const removeWhitespace = (str) => str?.replace(/\s+/g, '') || '';

export const convertStringToArrayBySeparator = (str, separator = ',') => {
  if (!str) return [];
  return str
    .split(separator)
    .map((v) => v.trim())
    .filter((v) => v.length)
    .map((v) => Number(v))
    .filter((nv) => Number.isFinite(nv));
};
